import React from 'react'
import { motion } from 'framer-motion'
import { Target, Eye, Award, Users, Zap, Shield } from 'lucide-react'

const About = () => {
  const values = [
    {
      icon: <Zap className="w-8 h-8" data-component-path="client/src/pages/About.jsx" data-component-line="1:1" data-component-id="client/src/pages/About.jsx:1:1" />,
      title: 'Innovation First',
      description: 'Pushing boundaries with cutting-edge technology solutions'
    },
    {
      icon: <Shield className="w-8 h-8" data-component-path="client/src/pages/About.jsx" data-component-line="2:1" data-component-id="client/src/pages/About.jsx:2:1" />,
      title: 'Enterprise Security',
      description: 'Bank-level security standards for all our solutions'
    },
    {
      icon: <Users className="w-8 h-8" data-component-path="client/src/pages/About.jsx" data-component-line="3:1" data-component-id="client/src/pages/About.jsx:3:1" />,
      title: 'Client Success',
      description: 'Your growth is our primary mission and commitment'
    },
    {
      icon: <Award className="w-8 h-8" data-component-path="client/src/pages/About.jsx" data-component-line="4:1" data-component-id="client/src/pages/About.jsx:4:1" />,
      title: 'Quality Excellence',
      description: 'Delivering world-class solutions that exceed expectations'
    },
  ]

  return (
    <div className="min-h-screen pt-20" data-component-path="client/src/pages/About.jsx" data-component-line="5:1" data-component-id="client/src/pages/About.jsx:5:1">
      <section 
        className="relative min-h-[60vh] flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1920)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        data-component-path="client/src/pages/About.jsx"
        data-component-line="6:3"
        data-component-id="client/src/pages/About.jsx:6:3"
      >
        <div className="absolute inset-0 bg-dark-primary/80" data-component-path="client/src/pages/About.jsx" data-component-line="14:5" data-component-id="client/src/pages/About.jsx:14:5"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/About.jsx" data-component-line="16:5" data-component-id="client/src/pages/About.jsx:16:5">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            data-component-path="client/src/pages/About.jsx"
            data-component-line="17:7"
            data-component-id="client/src/pages/About.jsx:17:7"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="22:9" data-component-id="client/src/pages/About.jsx:22:9">
              About <span className="text-gradient" data-component-path="client/src/pages/About.jsx" data-component-line="23:21" data-component-id="client/src/pages/About.jsx:23:21">The Dark Tech</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-component-path="client/src/pages/About.jsx" data-component-line="25:9" data-component-id="client/src/pages/About.jsx:25:9">
              Pioneering enterprise software solutions and ERP excellence as an Official Odoo Partner
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-dark-primary" data-component-path="client/src/pages/About.jsx" data-component-line="32:3" data-component-id="client/src/pages/About.jsx:32:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="33:5" data-component-id="client/src/pages/About.jsx:33:5">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-component-path="client/src/pages/About.jsx" data-component-line="34:7" data-component-id="client/src/pages/About.jsx:34:7">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              data-component-path="client/src/pages/About.jsx"
              data-component-line="35:9"
              data-component-id="client/src/pages/About.jsx:35:9"
            >
              <div className="flex items-center gap-3 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="40:11" data-component-id="client/src/pages/About.jsx:40:11">
                <Target className="w-8 h-8 text-neon-green" data-component-path="client/src/pages/About.jsx" data-component-line="41:13" data-component-id="client/src/pages/About.jsx:41:13" />
                <h2 className="text-3xl font-bold" data-component-path="client/src/pages/About.jsx" data-component-line="42:13" data-component-id="client/src/pages/About.jsx:42:13">Our Mission</h2>
              </div>
              <p className="text-gray-400 text-lg leading-relaxed mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="44:11" data-component-id="client/src/pages/About.jsx:44:11">
                To empower businesses worldwide with transformative software solutions that drive operational excellence, 
                enhance productivity, and unlock unprecedented growth through intelligent automation and enterprise-grade systems.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-component-path="client/src/pages/About.jsx" data-component-line="48:11" data-component-id="client/src/pages/About.jsx:48:11">
                As an Official Odoo Partner, we combine deep ERP expertise with custom software development to deliver 
                comprehensive solutions that scale with your ambitions.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              data-component-path="client/src/pages/About.jsx"
              data-component-line="55:9"
              data-component-id="client/src/pages/About.jsx:55:9"
            >
              <div className="flex items-center gap-3 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="60:11" data-component-id="client/src/pages/About.jsx:60:11">
                <Eye className="w-8 h-8 text-neon-green" data-component-path="client/src/pages/About.jsx" data-component-line="61:13" data-component-id="client/src/pages/About.jsx:61:13" />
                <h2 className="text-3xl font-bold" data-component-path="client/src/pages/About.jsx" data-component-line="62:13" data-component-id="client/src/pages/About.jsx:62:13">Our Vision</h2>
              </div>
              <p className="text-gray-400 text-lg leading-relaxed mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="64:11" data-component-id="client/src/pages/About.jsx:64:11">
                To be the global leader in enterprise software innovation, recognized for delivering cutting-edge SaaS platforms, 
                ERP transformations, and AI-powered automation that redefine industry standards.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-component-path="client/src/pages/About.jsx" data-component-line="68:11" data-component-id="client/src/pages/About.jsx:68:11">
                We envision a future where every business, regardless of size, has access to enterprise-grade technology 
                that drives sustainable competitive advantage.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-dark-secondary" data-component-path="client/src/pages/About.jsx" data-component-line="77:3" data-component-id="client/src/pages/About.jsx:77:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="78:5" data-component-id="client/src/pages/About.jsx:78:5">
          <div className="text-center mb-16" data-component-path="client/src/pages/About.jsx" data-component-line="79:7" data-component-id="client/src/pages/About.jsx:79:7">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="80:9" data-component-id="client/src/pages/About.jsx:80:9">
              Our Core <span className="text-gradient" data-component-path="client/src/pages/About.jsx" data-component-line="81:27" data-component-id="client/src/pages/About.jsx:81:27">Values</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-component-path="client/src/pages/About.jsx" data-component-line="83:9" data-component-id="client/src/pages/About.jsx:83:9">
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-component-path="client/src/pages/About.jsx" data-component-line="88:7" data-component-id="client/src/pages/About.jsx:88:7">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="glass-panel rounded-xl p-6 hover:neon-border transition-all"
                data-component-path="client/src/pages/About.jsx"
                data-component-line="90:11"
                data-component-id="client/src/pages/About.jsx:90:11"
              >
                <div className="w-16 h-16 bg-neon-green/10 rounded-xl flex items-center justify-center mb-4 text-neon-green" data-component-path="client/src/pages/About.jsx" data-component-line="96:13" data-component-id="client/src/pages/About.jsx:96:13">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold mb-2 text-white" data-component-path="client/src/pages/About.jsx" data-component-line="99:13" data-component-id="client/src/pages/About.jsx:99:13">{value.title}</h3>
                <p className="text-gray-400 text-sm" data-component-path="client/src/pages/About.jsx" data-component-line="100:13" data-component-id="client/src/pages/About.jsx:100:13">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-dark-primary" data-component-path="client/src/pages/About.jsx" data-component-line="107:3" data-component-id="client/src/pages/About.jsx:107:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="108:5" data-component-id="client/src/pages/About.jsx:108:5">
          <div className="text-center mb-16" data-component-path="client/src/pages/About.jsx" data-component-line="109:7" data-component-id="client/src/pages/About.jsx:109:7">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="110:9" data-component-id="client/src/pages/About.jsx:110:9">
              Official <span className="text-gradient" data-component-path="client/src/pages/About.jsx" data-component-line="111:23" data-component-id="client/src/pages/About.jsx:111:23">Odoo Partner</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto" data-component-path="client/src/pages/About.jsx" data-component-line="113:9" data-component-id="client/src/pages/About.jsx:113:9">
              Our partnership with Odoo enables us to deliver world-class ERP solutions backed by comprehensive 
              implementation expertise, custom module development, and ongoing support that ensures your success.
            </p>
          </div>

          <div className="glass-panel rounded-2xl p-8 md:p-12" data-component-path="client/src/pages/About.jsx" data-component-line="119:7" data-component-id="client/src/pages/About.jsx:119:7">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-component-path="client/src/pages/About.jsx" data-component-line="120:9" data-component-id="client/src/pages/About.jsx:120:9">
              <div data-component-path="client/src/pages/About.jsx" data-component-line="121:11" data-component-id="client/src/pages/About.jsx:121:11">
                <div className="text-4xl font-bold text-neon-green mb-2" data-component-path="client/src/pages/About.jsx" data-component-line="122:13" data-component-id="client/src/pages/About.jsx:122:13">50+</div>
                <p className="text-gray-400" data-component-path="client/src/pages/About.jsx" data-component-line="123:13" data-component-id="client/src/pages/About.jsx:123:13">Odoo Implementations</p>
              </div>
              <div data-component-path="client/src/pages/About.jsx" data-component-line="125:11" data-component-id="client/src/pages/About.jsx:125:11">
                <div className="text-4xl font-bold text-neon-green mb-2" data-component-path="client/src/pages/About.jsx" data-component-line="126:13" data-component-id="client/src/pages/About.jsx:126:13">100+</div>
                <p className="text-gray-400" data-component-path="client/src/pages/About.jsx" data-component-line="127:13" data-component-id="client/src/pages/About.jsx:127:13">Custom Modules Developed</p>
              </div>
              <div data-component-path="client/src/pages/About.jsx" data-component-line="129:11" data-component-id="client/src/pages/About.jsx:129:11">
                <div className="text-4xl font-bold text-neon-green mb-2" data-component-path="client/src/pages/About.jsx" data-component-line="130:13" data-component-id="client/src/pages/About.jsx:130:13">24/7</div>
                <p className="text-gray-400" data-component-path="client/src/pages/About.jsx" data-component-line="131:13" data-component-id="client/src/pages/About.jsx:131:13">Enterprise Support</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About